import { Check, X } from 'lucide-react';
import { Drawer } from 'vaul';
import type { ApiWatchlist, ChartSymbol } from '../types/api';
import { watchlistHasSymbol } from './AppShell.utils';

export function AddToWatchlistSheet({ symbol, watchlists, addingWatchlistId, onAdd, onOpenChange }: {
  symbol: ChartSymbol | null;
  watchlists: ApiWatchlist[];
  addingWatchlistId: string | null;
  onAdd(watchlist: ApiWatchlist): void;
  onOpenChange(open: boolean): void;
}) {
  return (
    <Drawer.Root open={Boolean(symbol)} onOpenChange={onOpenChange}>
      <Drawer.Portal>
        <Drawer.Overlay className="drawer-overlay" />
        <Drawer.Content className="drawer-content add-to-watchlist-sheet" aria-describedby={undefined}>
          <div className="sheet-handle" aria-hidden="true" />
          <div className="sheet-header add-to-watchlist-header">
            <div className="add-to-watchlist-title">
              <Drawer.Title asChild><strong>Add to watchlist</strong></Drawer.Title>
              {symbol && <span>{symbol.name}</span>}
            </div>
            <Drawer.Close asChild>
              <button type="button" className="icon-button" aria-label="Close add to watchlist"><X size={24} strokeWidth={1.9} /></button>
            </Drawer.Close>
          </div>
          <div className="sheet-option-list">
            {symbol && watchlists.map((watchlist) => {
              const added = watchlistHasSymbol(watchlist, symbol);
              const adding = addingWatchlistId === watchlist.id;
              return (
                <button
                  key={watchlist.id}
                  type="button"
                  className="sheet-option"
                  onClick={() => onAdd(watchlist)}
                  disabled={added || Boolean(addingWatchlistId)}
                >
                  <span>{watchlist.name}</span>
                  <span className={added ? 'sheet-option-state-added' : undefined}>{added ? <Check size={18} strokeWidth={2.4} /> : adding ? 'Adding...' : 'Add'}</span>
                </button>
              );
            })}
          </div>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  );
}
